'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('parking_policies', {
      url: '/account/parking/parking_policies?jurisdiction&sta_recid&policyName',
      template: '<parking-policies></parking-policies>',
      authenticate: true,
      params: {
        jurisdiction: null,
        sta_recid: null,
        policyName: null
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/parking/parking_policies/parking_policies.routes.js